import { RootState } from 'store';

import { useSelector } from 'react-redux';

import {
  checkIsLoading,
  checkIsLoadingDone
} from 'common/utils/checkLoading';

import { STATIONS_STATE } from '../../constants';

export const useStationsPriceReportLoadingStatus = () => useSelector(
  (state: RootState) => state[STATIONS_STATE].stationsPriceReport.loadingStatus
);

export const useIsStationsPriceReportLoading = () => {
  const stationsPriceReportLoadingStatus = useStationsPriceReportLoadingStatus();
  return checkIsLoading(stationsPriceReportLoadingStatus);
};

export const useIsStationsPriceReportDone = () => {
  const stationsPriceReportLoadingStatus = useStationsPriceReportLoadingStatus();
  return checkIsLoadingDone(stationsPriceReportLoadingStatus);
};

export const useStationsPriceReport = () => (
  useSelector((state: RootState) => state[STATIONS_STATE].stationsPriceReport.data)
);

const useStationsPriceReportCreatingStatus = () => useSelector(
  (state: RootState) => state[STATIONS_STATE].stationsPriceReport.creatingStatus
);

export const useIsStationsPriceReportCreating = () => {
  const stationsPriceReportCreatingStatus = useStationsPriceReportCreatingStatus();
  return checkIsLoading(stationsPriceReportCreatingStatus);
};

export const useIsStationsPriceReportCreatingDone = () => {
  const stationsPriceReportCreatingStatus = useStationsPriceReportCreatingStatus();
  return checkIsLoadingDone(stationsPriceReportCreatingStatus);
};

const useStationsPriceReportDownloadStatus = () => useSelector(
  (state: RootState) => state[STATIONS_STATE].stationsPriceReport.downloadStatus
);

export const useIsStationsPriceReportDownload = () => {
  const stationsPriceReportDownloadStatus = useStationsPriceReportDownloadStatus();
  return checkIsLoading(stationsPriceReportDownloadStatus);
};

export const useIsStationsPriceReportDownloadDone = () => {
  const stationsPriceReportDownloadStatus = useStationsPriceReportDownloadStatus();
  return checkIsLoadingDone(stationsPriceReportDownloadStatus);
};
